import axios from 'axios'
import { baseUrl } from './ApiUrlConstants'
const instance = axios.create({
  baseURL: baseUrl,
  timeout: 6000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Cache-Control': 'no-cache',
  },
})

export async function ApiRequest(options) {
  const onSuccess = function (response) {
    if (response && response.success) {
      return Promise.resolve(response)
    } else {
      return Promise.resolve(response)
    }
  }
  const onError = function (error) {
    return Promise.reject(error)
  }
  try {
    let response = ''
    response = await instance(options)
    return onSuccess(response)
  } catch (error) {
    return onError(error)
  }
}

export const apiMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT',
  PATCH: 'PATCH',
}
